import React from "react";

const UploadedAttachment = ({
  prvAttachments,
  setPrvAttachments,
  attachments,
  setAttachments,
}) => {
  // Unified render method
  const renderAttachment = (file, index, isPrevious = false) => {
    //alert(file.is_image === 1);
    const fileName = isPrevious ? file.file_name : file.name;
    const fileType = fileName?.split(".").pop().toUpperCase();
    const fileSize = !isPrevious && file.size ? `${(file.size / 1024).toFixed(2)} KB` : null;

    const isImage = isPrevious
      ? file.is_image === 1
      : /\.(png|jpe?g|gif)$/i.test(file.name);

    const fileUrl = isPrevious
      ? file.file_path
      : URL.createObjectURL(file);

    const handleRemove = () => {
      if (isPrevious) {
        const updated = [...prvAttachments];
        updated.splice(index, 1);
        setPrvAttachments(updated);
      } else {
        const updated = [...attachments];
        updated.splice(index, 1);
        setAttachments(updated);
      }
    };
    console.log(isImage ? fileUrl : "/assets/images/file-icon.svg");
    return (
      <div className="file-card mb-3" key={`${isPrevious ? "prev" : "new"}-${index}`}>
        <div className="file-info">
          <img
            src={isImage ? fileUrl : "/assets/images/file-icon.svg"}
            className="file-icon"
            alt="File"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
            onError={(e) => (e.target.src = "/assets/images/file-icon.svg")}
          />
          <div className="file-name">
            <h6>{fileName}</h6>
            <p>
              {fileType} {fileSize && `• ${fileSize}`}
            </p>
          </div>
        </div>
        <button
          className="remove-btn"
          onClick={handleRemove}
          aria-label={`Remove ${isPrevious ? "existing" : "new"} file ${fileName}`}
        >
          <img src="/assets/images/cross-icon.svg" alt="Remove" />
        </button>
      </div>
    );
  };

  return (
    <div className="fileDisplay">
      {prvAttachments?.map((file, index) => renderAttachment(file, index, true))}
      {attachments?.map((file, index) => renderAttachment(file, index, false))}
    </div>
  );
};

export default UploadedAttachment;
